export default {
    computed: {
        client() {
            return this.$store.getters['keyplan/getClient'];
        },
        benefits() {
            return this.$store.getters['keyplan/getBenefits'];
        },
        benefits_requested() {
            return this.$store.getters['keyplan/getBenefitsRequested'];
        },
        affordability() {
            return this.$store.getters['keyplan/getAffordability'];
        },
        age_range() {
            return this.$store.getters['keyplan/getAgeRange'];
        },

        departments() {
            return this.$store.getters['keyplan/getDepartments'];
        },
        products() {
            return this.$store.getters['keyplan/getProducts'];
        },
        types() {
            return this.$store.getters['keyplan/getTypes'];
        },

        kpError() {
            return this.$store.getters['keyplan/getKpError'];
        }
    },
};
